import { computed, makeObservable, observable, action } from "mobx"
import { CharacterStore } from "../characterstore/CharacterStore";
import { ReferStore } from "../referstore";
import { resetQueryByParams } from "./utils";
// @ts-ignore
import DialogRender from "./extend/DialogRender";
// @ts-ignore
import { DialogBuilder } from "./extend/DialogBuilder";
// @ts-ignore
import loadingElement from './extend/loadingElement';
import { PageCache } from "./extend/PageCache"
import { Result } from "./extend/Result";

export const PageStatusType = {
  INIT: 'init',
  EDIT: 'edit',
  BROWSE: 'browse',
  ADD: 'add'
}
interface PageStoreProps {
  status?: string,
  query?: any,
  params?: any,
  enumData?: object,
  userDefines?: object,
  multiData?: object,
  permissionsData?: object,
  history?: any,
  bRunInDesigner?: boolean,
  rootStore?: any
}
export class PageStore {
  status: string;
  storeType: string = 'PageStore'
  rootStore: any = {};
  query: any = {};
  params: any = {};
  enumData: any = {};
  metaData: any = {
    multiData: {},
    permissionsData: {},
    userDefines: {}
  }
  characterStore: CharacterStore
  referStore: ReferStore
  history: any = {};
  bRunInDesigner: boolean = false;
  bNeedRefresh: boolean = false;
  pageRefresh: string = new Date().toString()
  loadingCount: number;
  push: () => any;
  goBack: () => any;
  refresh: () => any;
  pageCache: PageCache;
  result: Result
  childPageStack: any = []
  dialogStack: any = [];

  constructor(props: PageStoreProps = {}) {
    const { status, query, params, enumData, userDefines, multiData, permissionsData, history, bRunInDesigner = false, rootStore } = props;
    const mode = [params?.mode, query?.mode, params?.billid, query?.billid].find(v => Object.values(PageStatusType).includes(v));
    const historyParams = history?.getHistoryParams?.() || {};
    this.status = historyParams.status ? historyParams.status : (status || mode || PageStatusType.BROWSE);
    this.query = Object.assign(this.query, query, historyParams.query)
    this.params = Object.assign(this.params, params, historyParams.params)
    resetQueryByParams(this.query, this.params);
    this.enumData = Object.assign(this.enumData, enumData)
    this.metaData = {
      multiData: multiData || {},
      permissionsData: permissionsData || {},
      userDefines: userDefines || {}
    }
    this.characterStore = new CharacterStore()
    this.referStore = new ReferStore(null, rootStore)
    this.bRunInDesigner = bRunInDesigner
    this.history = Object.assign(this.history, history);
    this.rootStore = rootStore
    this.loadingCount = 0;
    this.pageCache = new PageCache()
    this.result = new Result()

    makeObservable(this, {
      bRunInDesigner: observable,
      status: observable,
      loadingCount: observable,
      bNeedRefresh: observable,
      pageRefresh: observable,
      pageCache: observable,
      enumData: observable,
      isEdit: computed,
      isInit: computed,
      isBrowse: computed,
      hasResume: computed,
      edit: action,
      browse: action,
      getStatus: action,
      setStatus: action,
      startLoading: action,
      endLoading: action,
      setResult: action,
      childPageStack: observable,
      dialogStack: observable,
      currentChildPage: computed
    })

    this.push = (...props: any) => {
      props[0].params ? null : props[0].params = {}
      this.history.push?.(...props)
    }
    this.goBack = (...props: any) => {
      props[0] ? props[0].sourcePage = this.params.sourcePage : null;
      return this.history.goBack(...props)
    }
    this.refresh = (...props) => {
      this.history.refresh(...props)
    }
    // 渲染loading
    let loading = new loadingElement();
    loading.addLoading(this);
    // 渲染dialog
    let dialogRender = new DialogRender()
    dialogRender.render(this)
    // Fragment.js使用到history.openModal
    this.history.openModal = this.openModal
    this.history.closeModal = this.closeModal
  }

  // 页面状态相关
  add() {
    this.status = PageStatusType.ADD;
  }

  edit() {
    this.status = PageStatusType.EDIT;
  }

  browse() {
    this.status = PageStatusType.BROWSE;
  }

  getStatus() {
    return this.status;
  }

  setStatus(value: string) {
    this.status = value
  }

  get isInit() {
    return this.status === PageStatusType.INIT;
  }

  get isEdit() {
    return this.status === PageStatusType.EDIT;
  }

  get isBrowse() {
    return this.status === PageStatusType.BROWSE;
  }

  // 偏好配置
  get generalSetting() {
    return this.history.getGeneralSetting()
  }

  // 特性
  get feature() {
    return this.rootStore.globalConfig?.features || {}
  }

  // 公共配置
  get commonOption() {
    return this.rootStore.globalConfig?.commonOption || {}
  }

  // 页面loading相关api
  startLoading = () => {
    this.loadingCount += 1;
    return this.loadingCount;
  };

  endLoading = () => {
    // loadingCount等于0就不要endloading了
    if (this.loadingCount === 0) return this.loadingCount
    this.loadingCount -= 1;
    return this.loadingCount;
  }

  // Result上个页面返回结果
  setResult = (param: any = {})=> {
    this.result.setData(param)
    this.params = Object.assign({}, this.params, param)
  }

  getResult = ()=> {
    return this.result.getResult()
  }

  get hasResume () {
    return this.result.resume
  }

  // 以前的打开窗口的api兼容
  openModal = (props: any) => {
    const { uiType, component, showModal, bodyStyle, zIndex, mask, headStyle, title, closeButton, containerType, billNo, query, params, onOk, onCancel, ...modalProps } = props
    const titleView = this.DialogBuilder.createTitle(headStyle, title, closeButton)
    const dialog = this.DialogBuilder.create().setModalProps(modalProps).setTitleView(titleView)
    if (uiType === 'component') {
      const contentView = this.DialogBuilder.createCustomContent(component)
      dialog.setContentView(contentView)
    } else {
      const contentView = this.DialogBuilder.createBillContent(billNo, query, params)
      contentView.setContainerType(containerType)
      dialog.setContentView(contentView)
    }
    if (onOk && onCancel) {
      const footerView = this.DialogBuilder.createOkCancelFooter(onOk, onCancel)
      dialog.setFooterView(footerView)
    }
    dialog.setShowModal(showModal).setBodyStyle(bodyStyle).setZIndex(zIndex).setMask(mask)
    this.openDialog(dialog)
  }

  closeModal = (props: any) => {
    if (!this.dialogStack.length) {
      if (this.params.pageIsModal) {
        this.goBack()
      } else {
        console.warn("No modal can be pop");
      }
      return
    }
    const { allClean } = props
    if (allClean) this.dialogStack = []
    else this.closeDialog()
  }

  // dialogManage相关api
  get DialogBuilder() {
    return DialogBuilder
  }

  openDialog = (dialog: any) => {
    this.dialogStack.push(dialog)
  }

  closeDialog = (index: number = -1) => {
    if (index === -1) this.dialogStack.pop()
    else this.dialogStack.splice(index, 1)
  }

  // 移动端子页面相关api
  get currentChildPage() {
    if (this.childPageStack.length) {
      return this.childPageStack[this.childPageStack.length - 1]
    } else {
      return ''
    }
  }

  showPage = (pageCode: string) => {
    if (this.currentChildPage !== pageCode) this.childPageStack.push(pageCode)
  }

  closePage = () => {
    if (this.currentChildPage) this.childPageStack.pop()
  }

  // meta里面的数据
  get multiData () {
    return this.metaData.multiData
  }

  get permissionsData () {
    return this.metaData.permissionsData
  }

  get userDefines () {
    return this.metaData.userDefines
  }

  getPermissions = (action: string) => {
    return this.metaData.permissionsData[action]?.authFlag
  }
}
